<template>
  <div class="EventDetail">
    <app-menu :active.sync="menuOpened" :bottom="true" />
    <top-navbar :menu-opened.sync="menuOpened" />

   <div class="fixed-social-medias">
      <a
        v-for="item in socialNetworks"
        :key="item.icon"
        target="_blank"
        :href="item.href"
      >
        <component :is="item.icon" />
      </a>
    </div>

    <div class="event-container site-section-v">
      <header class="event-header">
        <div
            :style="`background-image: url('${event.image}')`"
          class="event-header-image"
        ></div>
        <div class="event-header-content">
          <label class="tag">Evento Online</label>
          <h2 class="text-blue">{{ event.title }}</h2>
          <div class="event-header-social-networks">
            <span>Compartilhe:</span>
            <span class="links">
              <a
                :href="item.href"
                v-for="item in socialNetworks"
                :key="item.icon"
                target="_blank"
              >
                <component :is="item.icon" width="25" />
              </a>
            </span>
          </div>
        </div>
      </header>

      <hr />

      <div class="event-info">
        <div class="event-info-left">
          <div class="item">
            <calendar-icon width="15" />
            <span>{{event.event_date}}</span>
          </div>
          <div class="item">
            <clock-2-icon width="15" />
            <span>{{event.event_hour}}</span>
          </div>
          <div class="item">
            <video-record-icon width="15" />
            <span
              >Vídeo conferência via
              <a class="text-blue"  :href="event.event_link" target="_blank"><strong>{{event.event_tool}}</strong></a></span
            >
          </div>
        </div>
        <div class="event-info-right">
          <a class="button button-orange is-block" :href="event.event_link" target="_blank">
            QUERO PARTICIPAR
          </a>
        </div>
      </div>

      <hr />

      <div class="event-content" v-html="event.text"></div>

      <hr />

      <!-- <tags :items="event.tags" />

      <hr /> -->

      <logo-card-horizontal theme="blue" />
      <hr />

      <profile-card-horizontal
        :to="{ name: 'page_about' }"
        name="Crivelli Advogados"
        description="Escritório especializado em Direito trabalhista, previdenciário, cível, sindical e direito médico"
      />
      <hr />

      <newsletter theme="orange" />
    </div>
  </div>
</template>

<script>
import AppMenu from "@/components/Menu";
// import ArrowHorizontal from "@/components/Svg/ArrowHorizontal";
import CalendarIcon from "@/components/Svg/CalendarIcon";
import HiperlinkIcon from "@/components/Svg/HiperlinkIcon";
import LogoIcon from "@/components/Svg/LogoIcon";
import MessegerIcon from "@/components/Svg/MessegerIcon";
import Newsletter from "@/components/Blog/Newsletter";
import PostCard from "@/components/Blog/PostCard";
import PostLinks from "@/components/Blog/PostLinks";
import SquareFacebookIcon from "@/components/Svg/SquareFacebookIcon";
import SquareLinkedinIcon from "@/components/Svg/SquareLinkedinIcon";
import Tags from "@/components/Blog/Tags";
import TopNavbar from "@/components/Blog/TopNavbar";
import LogoCardHorizontal from "@/components/LogoCardHorizontal";
import ProfileCardHorizontal from "@/components/ProfileCardHorizontal";

import TwitterIcon from "@/components/Svg/TwitterIcon";
import WhatsappIcon from "@/components/Svg/WhatsappIcon";
import Clock2Icon from "@/components/Svg/Clock2Icon";
import VideoRecordIcon from "@/components/Svg/VideoRecordIcon";
import api from "../../services/api";

export default {
  components: {
    AppMenu,
    // ArrowHorizontal,
    CalendarIcon,
    Clock2Icon,
    HiperlinkIcon,
    LogoIcon,
    LogoCardHorizontal,
    MessegerIcon,
    Newsletter,
    ProfileCardHorizontal,
    PostCard,
    PostLinks,
    SquareFacebookIcon,
    SquareLinkedinIcon,
    Tags,
    TopNavbar,
    TwitterIcon,
    WhatsappIcon,
    VideoRecordIcon,
  },

  async created() {
    const { data: event } = await api.get(`posts/${this.$route.params.slug}`);
    this.event = event;
    console.log(this.event)
  },

  computed: {
     socialNetworks() {
      return [
        {
          href: `https://api.whatsapp.com/send?text=${location.href}&utm_source=whatsapp&utm_medium=blog&utm_campaign=compartilhamento`,
          icon: "whatsapp-icon",
        },
        {
          href: `https://www.facebook.com/sharer/sharer.php?u=${location.href}&utm_source=facebook&utm_medium=blog&utm_campaign=compartilhamento`,
          icon: "square-facebook-icon",
        },
        {
          href: `https://twitter.com/intent/tweet?url=${location.href}&text=&utm_source=twitter&utm_medium=blog&utm_campaign=compartilhamento`,
          icon: "twitter-icon",
        },
        {
          href: `https://www.linkedin.com/shareArticle?mini=true&url=${location.href}&utm_source=linkedin&utm_medium=blog&utm_campaign=compartilhamento`,
          icon: "square-linkedin-icon",
        },
      ];
    },
  },

  data() {
    return {
      menuOpened: false,
      event: {},
      related_posts: [],
      video: null,
    };
  },
};
</script>
